class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      properties: { 
          Sender: document.getElementById('gift-card-sender') ? document.getElementById('gift-card-sender').value : null,
          Recipient: document.getElementById('gift-card-recipient') ? document.getElementById('gift-card-recipient').value : null
      },
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);

updateQuantityBtn();
updateVariantColor();
document.querySelector('quantity-input').onchange = function() { updateQuantityBtn(); };

function updateQuantityBtn() {
  const input = document.querySelector('quantity-input');
  const count = document.querySelector('quantity-input input.quantity__input');
  input.classList.remove('disabled-minus');
  input.classList.remove('disabled-plus');
  if (parseInt(count.value) <= parseInt(count.getAttribute('min'))) {
    input.classList.add('disabled-minus');
  }
  if (parseInt(count.value) >= parseInt(count.getAttribute('max'))) {
    input.classList.add('disabled-plus');
  }
}

function updateVariantColor() {
  if (document.querySelectorAll('input[name="Color"]').length) {
    const selected = document.querySelector('input[name="Color"]:checked').value;
    document.querySelector('input[name="Color"]:checked').parentElement.previousElementSibling.firstElementChild.innerText = selected;
  }
}